import { IApplicationState, TCardId } from '../../../../../../types/types';

export const getHighlightCardId = (
    state: IApplicationState
): TCardId => {
    return state.kanbanView.highlightCardId;
};
